/**
 * Auto-start sequences: server inserts a fixed rest between blocks.
 * Keep in sync with Backend AUTO_SEQUENCE_TRANSITION_PAUSE_SEC.
 */
export const AUTO_SEQUENCE_TRANSITION_PAUSE_SEC = 15;

export function readSequenceTransitionPauseRemaining(payload) {
  if (!payload || typeof payload !== "object") return null;
  const raw =
    payload.sequence_transition_pause_remaining ??
    payload.sequenceTransitionPauseRemaining;
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : null;
}

export function readAwaitingAutoSequenceStart(payload) {
  if (!payload || typeof payload !== "object") return false;
  if (payload.awaiting_auto_sequence_start != null) {
    return !!payload.awaiting_auto_sequence_start;
  }
  if (payload.awaitingAutoSequenceStart != null) {
    return !!payload.awaitingAutoSequenceStart;
  }
  return false;
}

export function formatTransitionPauseClock(seconds) {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, "0")}`;
}

/**
 * Merge manual / auto between-sequence gap fields from a socket payload onto an exercise.
 */
export function patchSequenceGapFieldsFromPayload(ex, data, { isTerminal = false } = {}) {
  if (!ex || !data) return ex || {};
  const next = { ...ex };
  if (data.awaiting_manual_sequence_start != null) {
    next.awaitingManualSequenceStart = !!data.awaiting_manual_sequence_start;
  } else if (isTerminal) {
    next.awaitingManualSequenceStart = false;
  }
  if (data.awaiting_auto_sequence_start != null) {
    next.awaitingAutoSequenceStart = !!data.awaiting_auto_sequence_start;
  } else if (isTerminal) {
    next.awaitingAutoSequenceStart = false;
  }
  const pauseRem = readSequenceTransitionPauseRemaining(data);
  if (pauseRem != null) {
    next.sequenceTransitionPauseRemaining = pauseRem;
  } else if (isTerminal || data.awaiting_auto_sequence_start === false) {
    next.sequenceTransitionPauseRemaining = 0;
  }
  if (data.next_sequence_number != null) {
    next.nextSequenceNumber = data.next_sequence_number;
  } else if (isTerminal) {
    next.nextSequenceNumber = null;
  }
  return next;
}

